import {
    loadSubscribedItems,
    subscribeToItem,
    unsubscribeFromItem,
    subscribeToAllItems,
    unsubscribeFromAllItems,
} from './notifications.utils';
import cloneDeep from 'lodash/cloneDeep';
const notifications = {
    namespaced: true,
    state: {
        fetching: false,
        error: {},
        subscribedItems: [],
    },
    mutations: {
        setFetching (state, { isFetching }) {
            state.fetching = isFetching;
        },
        setError (state, { error }) {
            state.error = error;
        },
        setSubscribedItems (state, { subscribedItems }) {
            state.subscribedItems = subscribedItems;
        },
    },
    actions: {
        async loadAll ({ commit }) {
            try {
                commit('setFetching', { fetching: true });
                const subscribedItems = await loadSubscribedItems();
                commit('setFetching', { fetching: false });
                commit('setSubscribedItems', { subscribedItems });
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
        async subscribeToItem ({ commit, state }, { targetId, itemType, flag = '', emailFrequency }) {
            try {
                await subscribeToItem(targetId, itemType, flag, { emailFrequency });
                const updatedSubscribedItems = cloneDeep(state.subscribedItems);
                updatedSubscribedItems.push({ targetId });
                commit('setSubscribedItems', { subscribedItems: updatedSubscribedItems });
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
        async subscribeToAllItems ({ commit, state }, { itemType, targetType }) {
            try {
                await subscribeToAllItems(itemType, targetType);
                const updatedSubscribedItems = cloneDeep(state.subscribedItems);
                updatedSubscribedItems.push({ notificationType: itemType, targetId: '*' });
                commit('setSubscribedItems', { subscribedItems: updatedSubscribedItems });
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
        async unsubscribeFromItem ({ commit, state }, { targetId, itemType }) {
            try {
                await unsubscribeFromItem(targetId, itemType);
                const updatedSubscribedItems = state.subscribedItems.filter((item) => item.targetId !== targetId);
                commit('setSubscribedItems', { subscribedItems: updatedSubscribedItems });
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
        async unsubscribeFromAllItems ({ commit, state }, { itemType, targetType }) {
            try {
                await unsubscribeFromAllItems(itemType, targetType);
                const updatedSubscribedItems = state.subscribedItems.filter(
                    (item) => !(item.targetId === '*' && item.notificationType === itemType),
                );
                commit('setSubscribedItems', { subscribedItems: updatedSubscribedItems });
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
    },
    getters: {
        subscribedItems: (state) => state.subscribedItems,
    },
};

export default notifications;
